import {clone} from '@/utils/helpers'

export default ({services}) => {
    let orderTravelers = []
    const getName = t => (t ? `${t.name?.[0]?.firstName || ''} ${t.name?.[0]?.lastName || ''}`.trim() : null)
    const isSameType = (t1, t2) => t1.isChild === t2.isChild
    const servicesSortedByMaxTravelers = [...services].sort((s1, s2) => s2.travelers.length - s1.travelers.length)
    const keysToMerge = ['isChild', 'phone', 'email', 'dateOfBirth', 'citizenshipId', 'passports', 'name', 'prefix']
    servicesSortedByMaxTravelers.forEach((s, serviceIndex) => {
        if (serviceIndex === 0) {
            orderTravelers = clone(s.travelers)
        } else {
            for (const t of s.travelers) {
                if (!getName(t)) {
                    if (
                        orderTravelers.filter(orderTraveler => isSameType(t, orderTraveler)).length <
                        s.travelers.filter(orderTraveler => isSameType(t, orderTraveler)).length
                    ) {
                        orderTravelers.push(clone(t))
                    }
                    continue
                }
                const orderTraveler =
                    orderTravelers.find(traveler => getName(traveler) === getName(t)) ||
                    orderTravelers.find(traveler => !getName(traveler) && isSameType(traveler, t))
                if (orderTraveler) {
                    keysToMerge.forEach(key => {
                        if (orderTraveler[key] === undefined && t[key] !== undefined) {
                            orderTraveler[key] = t[key]
                        } else if (key === 'passports' && orderTraveler[key]?.length === 0 && t[key]?.length) {
                            orderTraveler[key] = clone(t[key])
                        } else if (key === 'name') {
                            if (
                                orderTraveler[key]?.[0]?.firstName === undefined &&
                                t[key]?.[0]?.firstName !== undefined
                            ) {
                                orderTraveler[key][0].firstName = t[key][0].firstName
                            }
                            if (
                                orderTraveler[key]?.[0]?.lastName === undefined &&
                                t[key]?.[0]?.lastName !== undefined
                            ) {
                                orderTraveler[key][0].lastName = t[key][0].lastName
                            }
                        }
                    })
                } else {
                    orderTravelers.push(clone(t))
                }
            }
        }
    })
    orderTravelers?.sort((a, b) => a.isChild - b.isChild)
    return orderTravelers
}
